import { Contraente } from "./contraente";
import { TipologiaCostruttiva } from "./tipologia-costruttiva";
import { ClasseFabbricato } from "./classe-fabbricato";
import { StatoManutenzione } from "./stato-manutenzione";
import { AltroSoggetto } from "./altro-soggetto";
export class Fabbricato extends Contraente {
  static apiUrl: string = "fabbricati";

  amministratore: AltroSoggetto;
  verificato_su_planimetrie: boolean;
  verificato_su_google_earth: boolean;

  estensione: number;
  unita_misura_estensione_id: number;
  estensione_garage_servizi_piano_terra: number;
  totale_mc: number;
  valore_medio: number;
  numero_piani_fuori_terra: number;
  numero_piani_entro_terra: number;
  percentuale_superficie_piani_interrati: number;
  percentuale_uso_civile_uffici: number;
  percentuale_uso_commerciale: number;

  tipologia_costruttiva_id: number;

  anno_costruzione: number;
  anno_ristrutturazione: number;
  classe_fabbricato_id: number;
  stato_manutenzione_generale_id: number;
  stato_manutenzione_impianto_idrico_igenico_id: number;

  tipologia_costruttiva: TipologiaCostruttiva;
  classe_fabbricato: ClasseFabbricato;
  stato_manutenzione_generale: StatoManutenzione;
  stato_manutenzione_impianto_idrico_igenico: StatoManutenzione;

  altri_valori: number;
  costo_unitario: number;
  degrado_percentuale: number;

  // JSON table from Perizia Smart style
  preesistenza?: any[];

  deserialize(input: any): Fabbricato {
    let retV: Fabbricato = new Fabbricato();
    retV = super.deserialize(input) as Fabbricato;

    if (input?.amministratore) {
      this.amministratore = new AltroSoggetto().deserialize(
        input.amministratore
      );
    }

    if (input?.preesistenza) {
      // keep raw array as-is
      this.preesistenza = input.preesistenza;
    }

    if (retV?.totale_mc !== null && retV?.totale_mc !== undefined) {
      retV.totale_mc = +retV.totale_mc;
    }

    if (retV?.valore_medio !== null && retV?.valore_medio !== undefined) {
      retV.valore_medio = +retV.valore_medio;
    }

    return retV;
  }

  type = "fabbricato";

  get ubicazione_descrizione_rischio() {
    const separatore = " -";

    let risultato;
    try {
      risultato = this.ubicazione;

      risultato +=
        `${separatore} fabbricato ` + (this.classe_fabbricato?.nome ?? "");

      let i = this.numero_piani_entro_terra ?? 0;
      if (i == 0) risultato += ` costituito esclusivamente da`;
      else
        risultato +=
          ` costituito da ${i} pian` + (i == 1 ? `o` : `i`) + ` entro terra e`;

      i = this.numero_piani_fuori_terra ?? 0;
      risultato += ` ${i} pian` + (i == 1 ? `o` : `i`) + ` fuori terra`;

      risultato += `${separatore} costruito nel ` + this.anno_costruzione;

      if (this.anno_ristrutturazione)
        risultato += ` e ristrutturato nel ${this.anno_ristrutturazione}`;

      if (this.tipologia_costruttiva)
        risultato += `${separatore} ${this.tipologia_costruttiva.descrizione}`;

      if (this.stato_manutenzione_generale)
        risultato += `${separatore} in ${this.stato_manutenzione_generale.nome} stato di manutenzione generale`;

      i = +this.percentuale_uso_commerciale;
      risultato +=
        `${separatore} adibito per il ` +
        (i < 100
          ? +this.percentuale_uso_civile_uffici +
            `% a civili abitazioni ed uffici`
          : ``) +
        (+this.percentuale_uso_civile_uffici < 100
          ? ` e per il ` +
            +this.percentuale_uso_commerciale +
            `% a esercizi commerciali`
          : ``) +
        ` .`;
    } catch (e) {
      console.error(e);
      return risultato;
    }
    return risultato;
  }

  get nome_unita_misura_estensione() {
    if (!this.unita_misura_estensione_id) return "";
    let nomi = ["mc", "mq", "kg"];
    return nomi[this.unita_misura_estensione_id - 1];
  }

  get estensione_abitazioni_uffici() {
    if (!this.percentuale_uso_commerciale) return +this.estensione;
    return (+this.estensione * this.percentuale_uso_civile_uffici) / 100;
  }

  get estensione_commerciale() {
    if (!this.percentuale_uso_commerciale) return 0;
    return (+this.estensione * this.percentuale_uso_commerciale) / 100;
  }

  get costo_unitario_commerciale() {
    let costo_riferimento = +this.costo_unitario;
    const percentuale_valore_commerciale = 80;

    return (+costo_riferimento * percentuale_valore_commerciale) / 100;
  }

  get estensione_entro_terra() {
    const cubatura_entro_terra = 70;
    let estensione_singolo_piano_entro_terra =
      (+cubatura_entro_terra *
        (this.estensione / this.numero_piani_fuori_terra)) /
      100;
    let estensione_entro_terra =
      this.numero_piani_entro_terra * estensione_singolo_piano_entro_terra;

    return +estensione_entro_terra;
  }

  get costo_unitario_entro_terra() {
    let costo_riferimento = +this.costo_unitario;
    const percentuale_valore_entro_terra = 50;

    return (+costo_riferimento * percentuale_valore_entro_terra) / 100;
  }
  get costo_unitario_garage_servizi_piano_terra() {
    let costo_riferimento = +this.costo_unitario;
    const percentuale_valore_entro_terra = 30;

    return (+costo_riferimento * percentuale_valore_entro_terra) / 100;
  }

  get valore_abitazioni_uffici() {
    return (
      (+this.estensione_abitazioni_uffici || 0) * (+this.costo_unitario || 0)
    );
  }
  get valore_commerciale() {
    return (
      (+this.estensione_commerciale || 0) *
      (+this.costo_unitario_commerciale || 0)
    );
  }
  get valore_entro_terra() {
    return (
      (+this.estensione_entro_terra || 0) *
      (+this.costo_unitario_entro_terra || 0)
    );
  }
  get valore_garage_servizi_piano_terra() {
    return (
      (+this.estensione_garage_servizi_piano_terra || 0) *
      (+this.costo_unitario_garage_servizi_piano_terra || 0)
    );
  }

  get valore_a_nuovo() {
    return (
      (+this.valore_abitazioni_uffici || 0) +
      (+this.valore_commerciale || 0) +
      (+this.valore_entro_terra || 0) +
      (+this.altri_valori || 0) +
      (+this.valore_garage_servizi_piano_terra || 0)
    );
  }

  get valore_degradato() {
    return (
      ((+this.valore_a_nuovo || 0) / 100) *
      (100 - (+this.degrado_percentuale || 0))
    );
  }
}
